// @coverage-include-exempt: one exported string constant, no branches and no
// logic to measure. Its two consumers (partner-click-proof.ts and
// use-partner-click-proof.ts) are both in coverage.include and both assert on
// the value it produces.

/**
 * The one constant shared between the SERVER half of the browser-proof token
 * (`partner-click-proof.ts`, which imports `@opennextjs/cloudflare`) and the
 * CLIENT half (`use-partner-click-proof.ts`, which runs in the browser).
 *
 * It lives alone in its own module for a bundle reason, not a style one:
 * importing the param name straight from `partner-click-proof.ts` would drag
 * `getCloudflareContext` — a server-only module — into the client bundle. See
 * the root CLAUDE.md worker-bundle section and src/lib/stubs/CLAUDE.md for the
 * general shape of that trap.
 */

/** Query-param the Apply control carries the browser-proof token under. */
export const PARTNER_CLICK_PROOF_PARAM = "bp";
